module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_26.png?cfd2e4d045ab84fd72589acbcaa3814b";